const ruleEntryStatus = {
    STATUS_INACTIVE : 0,

    STATUS_ACTIVE : 1,

    STATUS_INVALID : 2,

    STATUS_DEBUG : 4

};

angular.module('gw-um-j2js')
    .constant('ruleEntryStatus', ruleEntryStatus);